module.exports = __webpack_public_path__ + "img/structure01.f14968cd.png";